import * as Actions from './reference-data.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

const initialState = {};

export const reduce = (state = initialState, action) => {
  const { data } = action;
  switch (action.type) {
    case APP_INITIALIZATION:
      return {
        ...state,
        data: {
          marketplaces: action?.initialData?.referenceData?.marketplaces,
          labelProviders: action?.initialData?.referenceData?.labelProviders,
          carriers: action?.initialData?.referenceData?.carriers,
          allTheCarriers: action?.initialData?.referenceData?.allTheCarriers,
          countries: action?.initialData?.referenceData?.countries,
          states: action?.initialData?.referenceData?.states,
          serviceClassifications: action?.initialData?.referenceData?.serviceClassifications,
          fulfillmentProviders: action?.initialData?.referenceData?.fulfillmentProviders,
          serviceReference: action?.initialData?.referenceData?.serviceReference,
        },
      };
    case Actions.GET_REFERENCE_DATA_SUCCESS:
      return {
        ...state,
        data,
      };
    default:
      return state;
  }
};

export { namespace } from './reference-data.reducer.metadata';
